import React, { FC, ReactNode } from 'react'
import { IssuesContextProvider } from './IssuesContext'
import { ShipmentContextProvider } from './ShipmentContext'

interface IIssuesWrapProps {
  children: ReactNode
}

const IssuesWrap: FC<IIssuesWrapProps> = ({ children }) => {
  return (
    <ShipmentContextProvider>
      <IssuesContextProvider>{children}</IssuesContextProvider>
    </ShipmentContextProvider>
  )
}

export default IssuesWrap
